<template>
    <form class="inline" ref="form" action="/booking/additional-details" method="get">
        <span>Click <button class="lowercase font-normal" type="submit"><span class="lowercase font-normal underline text-blue-500">here</span></button> if you're not redirected in a few seconds</span>
    </form>
</template>

<script>
export default {
    mounted() {
        this.$refs.form.submit();
    },
};
</script>
